import { Menu, Tooltip } from '@mantine/core';
import { IconPencil, IconUserPlus } from '@tabler/icons-react';
import { RevisionSingleActionProps } from 'components/tables/data/revision/types';
import { Link } from 'react-router-dom';
import { EDIT_FORM_PAGE_PATH, EDIT_REVISION_PAGE_PATH } from 'routes/paths';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Action performed by the users who have the permission to edit the revision.
 */
export default function EditAction({ revision, kind }: RevisionSingleActionProps) {
  const link =
    revision.kind === 'revision'
      ? EDIT_REVISION_PAGE_PATH.insert({ revisionId: revision.revisionId })
      : EDIT_FORM_PAGE_PATH.insert({ revisionId: revision.revisionId });

  const text = revision.technician
    ? 'Editovať'
    : revision.kind === 'revision'
    ? 'Určiť technika'
    : 'Určiť vypracovateľa';

  const icon = revision.technician ? <IconPencil /> : <IconUserPlus />;
  const variant = revision.technician ? 'secondary' : 'primary';

  if (kind === 'action-icon') {
    return (
      <Tooltip label={text} events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant={variant} size="md" component={Link} to={link}>
          {icon}
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button size="md" component={Link} to={link} leftIcon={icon} variant={variant} w={188}>
        {text}
      </Button>
    );
  }

  return (
    <Menu.Item component={Link} to={link} icon={icon} color="gray.8">
      {text}
    </Menu.Item>
  );
}
